import React from 'react';

const leaderboards = [
{
	title1: 'Équipes',
	title2: 'Différentiel par partie',
	imgPath: '/img/qo2019-s01a.png'
},
{
	title1: 'Joueurs',
	title2: 'Différentiel par partie',
	imgPath: '/img/qo2019-s02a.png'
},
{
	title1: 'Joueurs',
	title2: 'Pourcentage de victoires',
	imgPath: '/img/qo2019-s03a.png'
},
{
	title1: 'Joueurs',
	title2: "Tableau d'honneur",
	imgPath: '/img/qo2019-s04a.png'
},
];

class QuebecOpenLeaderboards2019 extends React.Component {

  constructor(props) {
		super(props);
		//this.dummyfunction = this.dummyfunction.bind(this);
	}

	render() {
		return (
			<div className="animated fadeIn">
      <div className="row">
      <div className="col-md-12 col-xs-12">
        <h4>QVNEA - Québec Open 2019 - Classements des Leaders</h4>
        <p>Cliquer sur les images pour les agrandir</p><br/>
      </div>
      </div>

      <div className="row">
				{this.dispLeaderboard(0)}
				{this.dispLeaderboard(1)}
				{this.dispLeaderboard(2)}
				{this.dispLeaderboard(3)}
      </div>

      <div className="row">
      <div className="col-md-12 col-xs-12">
				<a href="http://facebook.com/StateloStats" target="_blank">
          <img className="img-fluid" src="/img/suivez-facebook-01b.png" alt="suivez-nous" width="300"/>
				</a>
				<p><b>Profitez-en pour Aimer la page facebook de Statelo ! </b></p>
      </div>
      </div>
      </div>
		);
	}

	dispLeaderboard(idx) {
		return (
     <div className="col-md-3 col-xs-12">
        <p><b>{leaderboards[idx].title1}<br/>{leaderboards[idx].title2}</b></p>
        <a href={leaderboards[idx].imgPath}>
					<img className="img-fluid" src={leaderboards[idx].imgPath} alt={leaderboards[idx].title2} width="200"/><br/><br/>
				</a>
      </div>
		);
	}

}

export default QuebecOpenLeaderboards2019;